import SubscriptionSetupDetails from "./SubscriptionSetupDetails";

export default SubscriptionSetupDetails;